import { HttpAdapter } from '../../../config/http/http.adapter';
import { LoginResponse } from '../../../infraestructure/interfaces';
import { LoginMapper } from '../../../infraestructure/mappers';
import { User } from '../../entities';

interface Props {
  email: string;
  password: string;
  tokenCloudflare?: string;
}

export const LoginUserUseCases = async (
  fetcher: HttpAdapter,
  credentials: Props
): Promise<User> => {
  try {
    const response = await fetcher.post<LoginResponse>('/users/login', {
      email: credentials.email.toLowerCase(),
      password: credentials.password,
      tokenCloudflare: credentials?.tokenCloudflare,
    });

    return LoginMapper.fromLoginResponseToEntity(response);
  } catch (error: any) {
    if (error.status === 401) {
      //window.turnstile.reset();
      throw new Error(
        error?.response?.data?.message ||
          'Ocurrió un error, por favor intenta más tarde.'
      );
    } else {
      throw new Error('Ocurrió un error, por favor intenta más tarde.');
    }
  }
};
